import likely from 'ilyabirman-likely';

export default function init() {
  likely.initiate();
}